<template>
  <div class="page-content">
    <el-row>
      <el-col :span="12">
        <div style="padding-right: 40px">
          <vue-seamless-scroll
            :data="services"
            :class-option="optionSingleHeight"
            class="seamless-warp"
          >
            <ServiceItem
              v-for="(item, index) in services"
              :key="index"
              :service="item"
              :lang="lang"
              @click.native="serviceClick(item)"
            />
          </vue-seamless-scroll>
        </div>
      </el-col>
      <el-col :span="12">
        <News
          :news="datas"
          style="padding-left: 40px"
          @newsItemClick="newsItemClick"
          :lang="lang"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ServiceItem from "./ServiceItem";
import News from "@/components/News.vue";
import { getNews } from "@/api/data.js";
import { getService } from "@/api/data.js";
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  props: ["lang"],
  name: "Index",
  components: {
    ServiceItem,
    News,
    vueSeamlessScroll,
  },
  data() {
    return {
      services: [],
      datas: [],
    };
  },

  watch: {
    lang() {
      this.getData();
    },
  },
  computed: {
    optionSingleHeight() {
      return {
        singleHeight: 120,
        step: 3,
        waitTime: 3000,
      };
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    newsItemClick(data) {
      console.log(data);
      this.$emit("newItemClick", data);
    },
    serviceClick(item) {
      console.log(item);
      this.$emit("serviceClick", item);
    },
    getData() {
      let that = this;
      getNews()
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            let data = response.data.data;
            data.forEach((element) => {
              element.summary = element.title;
              element.enSummary = element.enTitle;
            });
            that.datas = data.length > 3 ? data.slice(0, 3) : data;
          } else {
            that.datas = [];
          }
        })
        .catch((error) => {
          console.log(error);
          that.datas = [];
        });

      getService()
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            let data = response.data.data;
            that.services = data;
          } else {
            that.services = [];
          }
        })
        .catch((error) => {
          console.log(error);
          that.services = [];
        });
    },
  },
};
</script>

<style>
/* .page-content {
  max-width: 1280px;
  margin: 0 auto;
} */
.messages {
}

h1 {
  color: #003399;
}

.seamless-warp {
  height: 500px;
  overflow: hidden;
}
</style>
